export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-13.e03f0fea.jpg";